import styled, { css } from "styled-components";
import { OverlayArrow as OverlayArrowPrimitive } from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

export const Arrow = styled(OverlayArrowPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { tooltip } = tokens;

    return css`
      svg {
        display: block;
        fill: ${tooltip.backgroundColor};
      }

      &[data-placement="top"] svg {
        transform: rotate(0deg);
      }

      &[data-placement="left"] svg {
        transform: rotate(-90deg);
      }

      &[data-placement="right"] svg {
        transform: rotate(90deg);
      }

      &[data-placement="bottom"] svg {
        transform: rotate(180deg);
      }
    `;
  }}
`;
